/* unplugin-vue-components disabled */import script from "./StageScheduleManager.vue?vue&type=script&setup=true&lang=js"
export * from "./StageScheduleManager.vue?vue&type=script&setup=true&lang=js"

import "./StageScheduleManager.vue?vue&type=style&index=0&id=670d2b2a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670d2b2a"]])

export default __exports__